import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../components/hooks/useFetch";
import Nav from "./Navbar";
import Footer from "./Footer";

export default function ExecutiveManagementDetails() {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const { loading, error, data } = useFetch(
    `${process.env.REACT_APP_API_URL}/board-of-directors/${id}`,
    token);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;
  if (!data) return <p>No data found</p>;
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const { firstName, middeName, lastName, passportNo, dateOfBirth, remark, position, published_at, created_at, updated_at, passport, profile, departements, educations } = data;

  const fullName = `${firstName} ${middeName} ${lastName}`;

  const profileImageUrl = profile && profile.length > 0 ? `${process.env.REACT_APP_API_URL}${profile[0].url}` : "default-image-url.jpg";

  const passportUrl = passport && passport.length > 0 ? `${process.env.REACT_APP_API_URL}${passport[0].url}` : "default-image-url.jpg";

  const departments = departements && departements.length > 0 ? departements.map(department => department.FieldName).join(", ") : "Not specified";

  const educationsInfo = educations && educations.length > 0 ? educations.map(education => education.TypesOfDegree).join(", ") : "Not specified";

  return (
    <>
      <Nav />
      <section className="pb-10 bg-blueGray-200">
        <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
          <div className="grid grid-cols-3 gap-4">
            <div className="mt-4 bg-white shadow-md rounded-lg text-left p-4">
              <h2 className="text-xl font-semibold mb-2"> {fullName}</h2>

              <p><strong>Date of Birth:</strong> {formatDate(dateOfBirth)}</p>
              <p><strong>Position:</strong> {position?.Title || "Not specified"}</p>
              <p><strong>Departments:</strong> {departments}</p>
              <p><strong>Educations:</strong> {educationsInfo}</p>
            </div>
            <div className="bg-indigo-300 p-4 rounded-lg shadow-lg">
              <img
                className="object-cover object-center h-48 w-96 rounded-lg"
                src={profileImageUrl}
                alt="Profile"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
